"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTikTokAdsDraft = void 0;
const tiktok_ads_1 = require("./tiktok-ads");
const tiktok_ads_matrix_1 = require("./tiktok-ads-matrix");
const validateTikTokAdsDraft = (draft) => {
    var _a, _b, _c, _d, _e, _f;
    const errors = [];
    const productType = (_a = draft.productType) !== null && _a !== void 0 ? _a : tiktok_ads_1.TikTokAdsProductType.IN_FEED;
    const objectiveRules = (0, tiktok_ads_matrix_1.getObjectiveRules)(draft.objective);
    const goalOption = (_b = (0, tiktok_ads_matrix_1.findGoalOption)(draft.objective, draft.optimizationGoal)) !== null && _b !== void 0 ? _b : (0, tiktok_ads_matrix_1.getDefaultGoalForObjective)(draft.objective);
    if (objectiveRules.blockedUntilIntegration) {
        errors.push((_c = objectiveRules.blockReason) !== null && _c !== void 0 ? _c : `${draft.objective} is not available for publish yet.`);
    }
    if (!draft.name.trim()) {
        errors.push("Campaign name is required.");
    }
    const minBudget = productType === tiktok_ads_1.TikTokAdsProductType.TOPVIEW
        ? tiktok_ads_1.TIKTOK_ADS_TOPVIEW_MIN_DAILY_BUDGET
        : tiktok_ads_1.TIKTOK_ADS_MIN_DAILY_BUDGET;
    if (draft.budgetAmount < minBudget) {
        errors.push(`Budget must be at least ${minBudget} in your account currency.`);
    }
    if (draft.budgetMode === tiktok_ads_1.TikTokAdsBudgetMode.LIFETIME && !draft.scheduleEnd) {
        errors.push("A lifetime budget needs an end date.");
    }
    if (productType === tiktok_ads_1.TikTokAdsProductType.TOPVIEW && !draft.scheduleEnd) {
        errors.push("TopView (Reservation) requires a schedule end date.");
    }
    if (draft.locationIds.length === 0) {
        errors.push("Select at least one target location.");
    }
    if (draft.ageGroups.length === 0) {
        errors.push("Select at least one age group.");
    }
    if (draft.placementType === tiktok_ads_1.TikTokAdsPlacementType.MANUAL &&
        draft.placements.length === 0) {
        errors.push("Select at least one placement.");
    }
    if (!draft.identityId) {
        errors.push("Choose the TikTok account the ad will be published as.");
    }
    if (!draft.mediaFileId) {
        errors.push("Select a video for the ad.");
    }
    if (!draft.adText.trim()) {
        errors.push("Ad text is required.");
    }
    if (draft.adText.length > tiktok_ads_1.TIKTOK_ADS_MAX_AD_TEXT_LENGTH) {
        errors.push(`Ad text must be ${tiktok_ads_1.TIKTOK_ADS_MAX_AD_TEXT_LENGTH} characters or fewer.`);
    }
    if (draft.objective === tiktok_ads_1.TikTokAdsObjective.LEAD_GENERATION) {
        if (!((_d = draft.instantFormPageId) === null || _d === void 0 ? void 0 : _d.trim())) {
            errors.push("Select a TikTok Instant Form (page_id) for Lead Generation.");
        }
    }
    else if (draft.objective === tiktok_ads_1.TikTokAdsObjective.WEB_CONVERSIONS) {
        if (!draft.landingPageUrl.trim()) {
            errors.push("Landing page URL is required.");
        }
        if (!((_e = draft.pixelId) === null || _e === void 0 ? void 0 : _e.trim())) {
            errors.push("Select a TikTok Pixel for Conversions.");
        }
        if (!((_f = draft.optimizationEvent) === null || _f === void 0 ? void 0 : _f.trim())) {
            errors.push("Select a Pixel optimization event for Conversions.");
        }
    }
    else if (!draft.landingPageUrl.trim()) {
        errors.push("Landing page URL is required.");
    }
    // CPC/CPV/CPM bids are auto-filled from the matrix on publish when missing.
    if (!(0, tiktok_ads_matrix_1.findGoalOption)(draft.objective, draft.optimizationGoal)) {
        // Allow legacy goals remapped on publish.
        const goal = String(draft.optimizationGoal);
        const remappable = goal === "VIDEO_VIEW" ||
            goal === "ENGAGEMENT" ||
            (draft.objective === tiktok_ads_1.TikTokAdsObjective.ENGAGEMENT &&
                (goal === "ENGAGED_VIEW" || goal === "VIDEO_VIEW"));
        if (!remappable) {
            errors.push(`Optimization goal ${draft.optimizationGoal} is not valid for ${draft.objective}. Use ${goalOption.goal}.`);
        }
    }
    return errors;
};
exports.validateTikTokAdsDraft = validateTikTokAdsDraft;
